import { render, staticRenderFns } from "./IssuesCategorySummary.vue?vue&type=template&id=40ba46a8&scoped=true&"
import script from "./IssuesCategorySummary.vue?vue&type=script&lang=js&"
export * from "./IssuesCategorySummary.vue?vue&type=script&lang=js&"
import style0 from "./IssuesCategorySummary.vue?vue&type=style&index=0&id=40ba46a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba46a8",
  null
  
)

export default component.exports